import * as zod from 'zod';

export const S3BucketState = zod.object({
  kind: zod.literal('S3Bucket'),
  lastOperation: zod.string().optional(),
  error: zod.string().optional(),
});

export type S3BucketState = zod.infer<typeof S3BucketState>;
